import "./styles.sass";

import React, { FC } from "react";
import { ReactComponent as CloseIcon } from "../../assets/icons/close-circle.svg";
import warning  from "../../assets/icons/warning.svg";
import Button from "../UI/button/GgButton";

interface ICOMModal {
  show: boolean;
  children: any;
  onClose: (state: boolean) => void;
  title?: string;
  size?: {
    width?: number | string;
    height?: number | string;
  };
  showSubmit?: boolean;
  onSubmit?: () => void;
  submitLabel?: string;
  onPressDelete?: () => void;
}

const ConModal: FC<ICOMModal> = ({
  show,
  children,
  onClose,
  size,
  title,
  showSubmit,
  onSubmit,
  submitLabel,
  onPressDelete,
}) => {
  return (
    <>
      {show && (
        <div className={`modal show`}>
          <div className="background" onClick={() => onClose(false)} />
          <div
            className="modal-container nav"
            style={{height:"50vh", width:"30vw", borderRadius:"1rem"}}
          >
            <div className="tool-top-panel">
              <span className="tool-top-panel-item title">
              {title}
              </span>
              <span className="tool-top-panel-item close">
                {showSubmit && (
                  <Button label={submitLabel || "Save"} onPress={onSubmit} />
                )}
                <CloseIcon onClick={() => onClose(false)} className="icon" />
              </span>
            </div>
            <div className="modal-body" style={{ marginTop: "10px", display:"flex", justifyContent:"space-between", alignItems:"center", flexDirection:"column", paddingLeft:"0px" }} >
                <div>
                    {children}
                </div>
                <div className="image_changer">
                    <img src={warning} alt="" style={{width:"12rem", opacity:"0.6"}}/>
                </div>
                <div>
                <Button 
                    label="Delete"
                    type="submit"
                    style={{width:"20rem"}}
                    onPress={onPressDelete} 
                />
                </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConModal;
